import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { hash } from '@ember/helper'
import { notEq } from 'ember-truth-helpers'
import type TeacherToolkitRoute from 'teacher-ui-client/subscription-type/teacher-toolkit/route'
import { BreadcrumbSeparator } from 'teacher-ui-client/components/base/breadcrumbs/separator'
import { BreadcrumbLinkTo } from 'teacher-ui-client/components/base/breadcrumbs/link-to'

interface Signature {
  Args: {
    model: ModelFor<TeacherToolkitRoute>
  }
}

class TeacherToolkitPage extends Component<Signature> {
  get categoryBreadcrumbs() {
    return this.args.model.categoriesForQuery.slice(1) // Removes the root breadcrumb of reading || maths
  }

  <template>
    <div class="mx-auto my-8 w-full px-8">
      <nav class="mb-4 p-4" data-test-breadcrumbs>
        {{#each this.categoryBreadcrumbs as |categoryBreadcrumb index|}}
          {{#if (notEq index 0)}}<BreadcrumbSeparator />{{/if}}
          <BreadcrumbLinkTo
            @route="subscription-type.teacher-toolkit"
            @query={{hash category=categoryBreadcrumb.fields.path}}
          >
            {{categoryBreadcrumb.fields.name}}
          </BreadcrumbLinkTo>
        {{/each}}
      </nav>

      {{outlet}}
    </div>
  </template>
}

export default RouteTemplate(TeacherToolkitPage)
